import React from 'react';

import { SearchDropDownHolderComponent } from '../../common/dropDownComponents';
import { SelectLabel, SelectOuterHolder } from './SearchDropDownWrapper.styles';

const SearchDropDown = (props) => {
  const { children, label, className, center, zIndexOff } = props;

  return (
    <SelectOuterHolder center={center} className={className}>
      {label && <SelectLabel>{label}&nbsp;</SelectLabel>}
      <SearchDropDownHolderComponent zIndexOff={zIndexOff}>{children}</SearchDropDownHolderComponent>
    </SelectOuterHolder>
  );
};

export default SearchDropDown;
